"use client";

import React from "react";
import { ArrowRight, ArrowUp, Facebook, Instagram, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
export default function InformasiKontak() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const footerNavLinks = [{
    name: "HOME",
    path: "/"
  }, {
    name: "LIVE",
    path: "/live/"
  }, {
    name: "ZONA PP",
    path: "/zona-pp/"
  }, {
    name: "KIRIM",
    path: "/kirim-berita/"
  }, {
    name: "POJOK OJOL",
    path: "/pojok-ojol/"
  }];
  const socialLinks = [{
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }, {
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }, {
    name: "Facebook",
    icon: Facebook,
    href: "#"
  }];
  return <section data-section-id="140739" id="navigasi-bawah-sticky" className="bg-background text-foreground py-12 md:py-16 lg:py-20 px-6 sm:px-8 md:px-12 lg:px-24 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-10 lg:gap-8">
          <div className="flex flex-col items-start">
            <div className="mb-6">
              <h3 className="text-sm font-semibold tracking-widest uppercase mb-6 text-foreground font-heading">
                Navigasi Utama
              </h3>
              <nav className="flex flex-col gap-3">
                {footerNavLinks.map((link, i) => <Link key={link.name} to={link.path} data-index={i} className="text-sm font-body text-muted-foreground hover:text-primary transition-colors tracking-wide">
                    {link.name}
                  </Link>)}
              </nav>
            </div>
            
            <div className="mb-2 text-[#B30000] font-heading font-bold text-xs md:text-sm tracking-widest uppercase">
              SEKALI LAYAR TERKEMBANG SURUT KITA BERPANTANG
            </div>
            <Link to="/" className="mb-6 flex items-center group">
              <WvcLogo className="h-8 md:h-10 w-auto transition-transform duration-300 group-hover:scale-105" />
            </Link>
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed font-body">
              ABADI.NEWS adalah portal berita modern yang menyajikan informasi terkini, akurat, dan terpercaya. Kami berkomitmen menghadirkan jurnalisme berkualitas dengan perspektif tajam untuk pembaca nasional.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-widest uppercase mb-6 text-foreground font-heading">
              Layanan Redaksi
            </h3>
            <div className="overflow-x-auto">
              <Table className="[&_td]:p-0 [&_td]:py-3 [&_tr]:border-border/30">
                <TableBody>
                  <TableRow className="hover:bg-transparent border-b">
                    <TableCell className="text-muted-foreground text-sm font-body">Redaksi Nasional</TableCell>
                    <TableCell className="text-right font-mono text-sm text-primary">24 Jam</TableCell>
                  </TableRow>
                  <TableRow className="hover:bg-transparent border-b">
                    <TableCell className="text-muted-foreground text-sm font-body">Layanan Iklan</TableCell>
                    <TableCell className="text-right font-mono text-sm text-foreground">09:00 - 17:00</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-widest uppercase mb-6 text-foreground font-heading">
              Media Sosial
            </h3>
            <ul className="space-y-4 md:space-y-5">
              {socialLinks.map((social, i) => <li key={social.name} data-index={i}>
                  <Link to={social.href} className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group w-fit">
                    <social.icon className="size-5 group-hover:-translate-y-0.5 transition-transform duration-400" strokeWidth={1.5} />
                    <span className="text-sm font-body">{social.name}</span>
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-widest uppercase mb-6 text-foreground font-heading">
              Langganan Berita
            </h3>
            <p className="text-muted-foreground text-sm md:text-base mb-4 font-body">
              Dapatkan rangkuman berita terpopuler dan investigasi eksklusif langsung di kotak masuk Anda.
            </p>
            <div className="relative mt-2 group">
              <Input type="email" placeholder="Alamat Email Anda" className="w-full bg-transparent border-0 border-b border-border px-0 pb-2 focus-visible:ring-0 focus-visible:border-primary pr-10 text-sm md:text-base transition-colors font-body" />
              <Button variant="ghost" size="icon" className="absolute right-0 top-0 h-8 w-8 hover:bg-transparent text-muted-foreground hover:text-primary transition-colors" aria-label="Daftar Berita">
                <ArrowRight className="size-4" strokeWidth={1.5} />
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs md:text-sm text-muted-foreground font-body !font-bold !italic">© ABADI.NEWS | ZONA PP. Hak cipta dilindungi undang-undang. Profesional & Terpercaya.</p>
          <Button variant="ghost" size="icon" onClick={scrollToTop} className="rounded-lg border border-border/50 hover:bg-accent hover:text-primary transition-all duration-400 lg:h-10 lg:w-10" aria-label="Kembali ke atas">
            <ArrowUp className="size-4" strokeWidth={1.5} />
          </Button>
        </div>
      </div>
    </section>;
}